import React from 'react';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip/Tooltip';
import { useTranslation } from '../../../contexts/translation';
interface Props {
  label: string;
  isFullscreen?: boolean;
  onClick: () => void;
}

export function TimezoneChangerButton({ label, isFullscreen, onClick }: Props) {
  const { t } = useTranslation();
  return (
    <Tooltip title={t('general.timezone.label-timezone')}>
      <Button
        onClick={onClick}
        style={{
          fontSize: '0.6rem',
          top: (isFullscreen ? 3 : 12) + '%',
          marginRight: '0.6rem',
        }}
      >
        {label}
      </Button>
    </Tooltip>
  );
}
